import { render, staticRenderFns } from "./promotion-maintenance.vue?vue&type=template&id=97a64992&scoped=true"
import script from "./promotion-maintenance.vue?vue&type=script&lang=js"
export * from "./promotion-maintenance.vue?vue&type=script&lang=js"
import style0 from "./promotion-maintenance.vue?vue&type=style&index=0&id=97a64992&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a64992",
  null
  
)

export default component.exports